// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestionCard-cls1__RL","cls2":"SuggestionCard-cls2_YOR SuggestionCard-cls1__RL","small":"SuggestionCard-small_Go2"};